import { render, staticRenderFns } from "./ImportFilters.vue?vue&type=template&id=a845ecf0&scoped=true&"
import script from "./ImportFilters.vue?vue&type=script&lang=ts&"
export * from "./ImportFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a845ecf0",
  null
  
)

export default component.exports